export default __webpack_public_path__ + "static/media/outer-bottom-corners-rounded-3.8f0f3ef7.webp";